import { useCallback, useMemo } from 'react';
import { Browser } from '@capacitor/browser';

import {
  CATCH_POWER_MANUFACTURER_ID,
  SOLAR_ANALYTICS_MANUFACTURER_ID,
} from 'clipsal-cortex-utils/src/constants/common-constants';

import { InstalledDevice } from '../../api/api-device';

export const useConfigureInSolarAnalytics = (meters: InstalledDevice[]) => {
  const { siteHasSolarAnalyticsMeter, solarAnalyticsMeterId } = useMemo(() => {
    const sonarAnalyticsMeters = meters?.filter(
      (meter) => meter.meta_data.manufacturer_id === SOLAR_ANALYTICS_MANUFACTURER_ID
    );

    // Catch Power meters are also Solar Analytics meters, so we include them here
    const catchMeters = meters?.filter((meter) => meter.meta_data.manufacturer_id === CATCH_POWER_MANUFACTURER_ID);

    return {
      siteHasSolarAnalyticsMeter: !!sonarAnalyticsMeters?.length || !!catchMeters?.length,
      solarAnalyticsMeterId: sonarAnalyticsMeters?.[0]?.site_identifier ?? catchMeters?.[0]?.site_identifier ?? '',
    };
  }, [meters]);

  const handleConfigureInSolarAnalytics = useCallback(() => {
    const solarAnalyticsUrl = `https://clipsalsolar.solaranalytics.com/au/dashboard/${solarAnalyticsMeterId}`;
    Browser.open({ url: solarAnalyticsUrl });
  }, [solarAnalyticsMeterId]);

  return {
    siteHasSolarAnalyticsMeter,
    solarAnalyticsMeterId,
    handleConfigureInSolarAnalytics,
  };
};
